import styles from './About.module.css';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className={styles.about}>
      <motion.h1 animate={{ y: 10 }} className={styles.about_title}>
        Mer om det här företaget
      </motion.h1>
      <hr className={styles.hr_about_hr}></hr>
      <div className={styles.column_left}>
        <p className={styles.about_para}>Några punkter att känna till:</p>
      </div>
      <div className={styles.column_right}>
        <ul>
          <li className={styles.li}>VD: Ingvar Axelssons</li>
          <li className={styles.li}>Start år: 1975</li>
          <li className={styles.li}>Omsättning: 50 000/år</li>
          <li className={styles.li}>Certifcat: Allän behörighet Elarbeten</li>
          <li className={styles.li}>
            Företagets Status: Hobby aktiv penstionär
          </li>
        </ul>
      </div>
    </div>
  );
};

export default About;
